import Radio from './radio'

const ListItem = ({ form, item, watcherDatasetId, setOpenKnowledge }) => {
  return (
    <div
      key={item.folder_id}
      style={{
        margin: '2px 6px',
        padding: '0px 8px',
        flex: '1 1 50%',
      }}
      className="custom-select-wrapper h-44px flex items-center cursor-pointer box-border hover:bg-[rgba(0,0,0,0.03)] hover:rounded-8px"
      onClick={e => {
        e.stopPropagation();

        const selectedValue = form.getFieldValue('dataset_id') || '';
        if (selectedValue != item.folder_id) {
          form.setFieldsValue({
            dataset_id: item.folder_id,
          });
        } else {
          form.setFieldsValue({
            dataset_id: undefined,
          });
        }
        setOpenKnowledge(false);
      }}
    >
      <Radio
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
        value={item?.folder_id}
        className="custom-checkbox-label"
        currentValue={watcherDatasetId}
      >
        <span className="text-14px font-normal">{item?.name}</span>
      </Radio>
    </div>
  );
};

export default ListItem;
